import { ref, watch, onBeforeUnmount } from "vue";
import { useUserStore } from "@/stores/user";
import { watch as watchLive } from "@/components/toLoad/live";

function details(raw = {}, kind = "customer") {
  return {
    kind,
    firstName: raw.firstName || "",
    lastName: raw.lastName || "",
    name: raw.name || "",
    avatar: typeof raw.avatar === "string" ? raw.avatar : (raw.avatar && raw.avatar.link) || "",
  };
}

export function useModuleItems(collection, { party = "", parties = "" } = {}) {
  const store = useUserStore();
  const items = ref([]);
  const loading = ref(true);
  const companyId = ref("");

  let docs = [];
  let customers = {};
  let companies = {};
  let unsubs = [];

  const lookup = (id) => (customers[id] ? details(customers[id]) : details(companies[id], "company"));

  function rebuild() {
    items.value = docs.map((document) => {
      const data = document.data() || {};
      const item = { ...data, id: document.id };
      if (party) item.customerDetails = lookup(data[party]);
      if (parties) item.participantsData = (data[parties] || []).map(lookup);
      return item;
    });
    loading.value = false;
  }

  function collect(setter) {
    return (res) => {
      const next = {};
      for (const document of res.docs || []) next[document.id] = document.data() || {};
      setter(next);
      rebuild();
    };
  }

  function stop() {
    unsubs.forEach((unsub) => typeof unsub === "function" && unsub());
    unsubs = [];
  }

  function start(id) {
    stop();
    loading.value = true;
    companyId.value = id;

    unsubs.push(watchLive(id, collection, (res) => {
      docs = res.docs || [];
      rebuild();
    }));

    if (party || parties) {
      unsubs.push(watchLive(id, "customers", collect((next) => { customers = next; })));
      unsubs.push(watchLive(id, "companies", collect((next) => { companies = next; })));
    }
  }

  watch(() => store.user?.company, (id) => id && start(id), { immediate: true });
  onBeforeUnmount(stop);

  return { items, loading, companyId };
}
